export enum SocialIncomeTypes {
  UNEMPLOYMENT = "arbeitslosengeld",
  PARENTAL = "elterngeld",
  INSOLVENCY = "insolvenzgeld",
  SICKNESS = "krankengeld",
  MATERNITY = "mutterschaftsgeld",
  INJURY = "verletztengeld",
  TRANSITION = "uebergangsgeld",
  OTHER = "other"
}
